export default __webpack_public_path__ + "static/media/img404.efae2b42.png";